
  import {Component, Vue} from "vue-property-decorator";
  import {httpResource} from "@/resources/http.resource";
  import {IScreenPay} from "@/modules/ScreenPay/interfaces/screen-pay.interface";
  import QrcodeVue from 'qrcode.vue'
  import {IApp} from "@/interfaces/app.interface";
  import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {bus} from "@/plugins/bus";
  import SPAdditionalControls from "@/modules/ScreenPay/components/SPAdditionalControls.vue";

  @Component({
    components: {
      SPAdditionalControls,
      QrcodeVue,
    },
  })
  export default class ScreenPayIntro extends Vue {
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    $refs: any;
    formModel = {
      carNumber: '',
    };
    hasRequest = false;
    invalidText = '';
    payInfo: IScreenPay.IPayInfo = {
      description: '',
      sum: 0,
      hasNumber: false,
      phoneSecurity: '',
      freeExitFlag: true,
      fiscalQRCode: null,
      disablePayFlag: false,
      saldoInfo: '',
    };
    archiveCarNumbers = [];
    displayMobileOverlay = false;
    isTouchDevice = false;
    touchStartTime = 0;
    gateId = null;
    parkId = null;

    get isUser() { return this.$store.state.auth.isUser; }

    async mounted() {
      const storageArchiveCarNumbers = localStorage.getItem(IScreenPay.LocalStorageKeys.CarNumbers);
      this.archiveCarNumbers =  storageArchiveCarNumbers ? JSON.parse(storageArchiveCarNumbers) : [];
      const storageLastCarNumber = localStorage.getItem(IScreenPay.LocalStorageKeys.LastCarNumber);
      this.formModel.carNumber =  storageLastCarNumber ? JSON.parse(storageLastCarNumber) : '';

      if (this.$route.query) {
        this.gateId = this.$route.query.gate ? +this.$route.query.gate : null;
        this.parkId = this.$route.query.parkId ? +this.$route.query.parkId : null;
      }

      if (this.gateId) {
        this.formModel.carNumber = '';
        await this.getPayInfo(true);
      }

      if (this.formModel.carNumber) await this.checkNumber(this.formModel.carNumber);

      this.detectTouchDevice();
    }

    async checkNumber(value) {
      if (value && value.length >= 7 && value.length <= 9) {
        this.invalidText = '';
        await this.getPayInfo();
      }
      else if (value && value.length < 7) {
        this.invalidText = 'Номер должен состоять минимум из 7 символов, включая код региона';
        this.hasRequest = false;
      }
      else {
        this.invalidText = '';
        this.hasRequest = false;
      }
    }

    async openPaymentModal() {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'payment',
        dialogName: 'payByCardPopup',
        secondaryPopup: true,
        payload: {
          carNumber: this.formModel.carNumber,
          tSum: this.payInfo.sum,
          gateId: this.gateId,
          closeBalance: true,
          needChekNumber: true,
          closeAction: async () => {
            await this.getPayInfo();
          },
        },
      });

      const hasInArchive = this.archiveCarNumbers.find(item => item.value === this.formModel.carNumber);
      if (!hasInArchive) {
        this.archiveCarNumbers.push({ value: this.formModel.carNumber });
        localStorage.setItem(IScreenPay.LocalStorageKeys.CarNumbers, JSON.stringify(this.archiveCarNumbers));
      }
      localStorage.setItem(IScreenPay.LocalStorageKeys.LastCarNumber, JSON.stringify(this.formModel.carNumber));
    }

    async getPayInfo(withoutCarNumber = false) {
      let asyncAction = async () => {
        let action = IScreenPay.Action;
        let params: any = { carNumber: this.formModel.carNumber, };

        if (withoutCarNumber) delete params.carNumber;

        const optionalParams = ['parkId', 'gateId',];
        optionalParams.forEach((item) => { if (this[item]) params[item] = this[item]; });
        const { data: { result: { CarSaldo: carInfo }} } = await httpResource.httpAction({ action, params });

        if (carInfo && carInfo.saldo) {
          this.payInfo = {
            ...carInfo,
            description: carInfo.dolgInfo,
            sum: +carInfo.saldo,
            hasNumber: !carInfo.carNumberNotFound,
          };
          this.hasRequest = true;
        }

        if (withoutCarNumber) this.formModel.carNumber = carInfo.carNumber;
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    confirmPayment() {
      this.payInfo.hasNumber = true;
      this.payInfo.description = 'Заезд не найден';
    }

    createFilter(queryString) {
      return (item) => item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    }

    querySearch(queryString, cb) {
      const ArchiveCarNumbers = this.archiveCarNumbers;
      const results = queryString ? ArchiveCarNumbers.filter(this.createFilter(queryString)) : ArchiveCarNumbers;

      if (this.isTouchDevice) {
        results.forEach((item: any) => {
          item.onTouchStart = this.handleTouchStart;
          item.onTouchEnd = (e: TouchEvent) => this.handleSuggestionTouch(item, e);
        });
      }

      cb(results);
    }

    async clearNumber() {
      this.formModel.carNumber = '';
      this.payInfo = {
        description: '',
        sum: 0,
        hasNumber: false,
        phoneSecurity: '',
        freeExitFlag: true,
        fiscalQRCode: null,
        disablePayFlag: false,
        saldoInfo: '',
      };
      this.hasRequest = false;
      await this.$nextTick();
      this.$refs.numberInput.focus();
    }

    async inputFocus() {
      const inputElement = this.$refs.numberInput.$el.querySelector('input');
      const contentBlock = document.querySelector('.app-page__content');

      this.displayMobileOverlay = true;
      await this.$nextTick();

      if (inputElement && contentBlock) {
        const inputRect = inputElement.getBoundingClientRect();
        const contentRect = contentBlock.getBoundingClientRect();
        const scrollTop = inputRect.top - contentRect.top + contentBlock.scrollTop - 20;

        setTimeout(() => {
          contentBlock.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }, 500);
      }
    }

    inputBlur() {
      this.displayMobileOverlay = false;
    }

    async handleSelect(item: any) {
      this.formModel.carNumber = item.value;
    }

    detectTouchDevice() {
      this.isTouchDevice = 'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        (navigator as any).msMaxTouchPoints > 0;
    }

    handleTouchStart(elem) {
      elem.target.parentNode.click();
      this.touchStartTime = Date.now();
    }

    handleSuggestionTouch(item: any, event: TouchEvent) {
      event.preventDefault();
      event.stopPropagation();

      if (Date.now() - this.touchStartTime < 300) {
        this.handleSelect(item);
      }
    }
  }
